import React from 'react'

const NotFound = () => {
  return (
    <>
      <h1>Looking for something?</h1>
      <p>
        <span className="i">{window.location.href}</span> doesn't exist.
      </p>
    </>
  )
}

export default NotFound
